import React from 'react';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  PROCEDURE_CARRIER_TYPES,
  PROCEDURE_SZLT_TYPES,
  PROCEDURE_TYPE_LIST,
  PROCEDURE_VEHICLE_TYPES,
} from '../../../configs';

export default function ApplicationSelectProcedure(props) {
  const {
    onClose = () => {},
    onSelectProcedure = () => {},
  } = props;
  const { formatMessage } = useIntl();
  const renderButton = (item, key) => (<Button variant="secondary" key={key} className="" onClick={() => onSelectProcedure(item)}>{formatMessage({ id: `procedure.type.${item}` })}</Button>);
  return (
    <Dialog
      className="application-select-procedure-dialog"
      onClose={onClose}
      open
    >
      <DialogTitle header="Выбор услуги" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="application-select-procedure-content">
        <div className="f4">Услуги перевозчика</div>
        <div className="application-select-procedure-column mt-3">{PROCEDURE_CARRIER_TYPES.map(renderButton)}</div>
        <div className="f4 mt-3">Услуги легкового такси</div>
        <div className="application-select-procedure-column mt-3">{PROCEDURE_VEHICLE_TYPES.map(renderButton)}</div>
        <div className="f4 mt-3">Услуги СЗЛТ</div>
        <div className="application-select-procedure-column mt-3">{PROCEDURE_SZLT_TYPES.map(renderButton)}</div>
      </DialogContent>
      <DialogFooter>
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={onClose}>Отменить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
